import { Cell, Row, Skeleton } from '@vizit/atoms';
import { cva, cx } from '@vizit/theme';
import * as React from 'react';

const rowClasses = cva({
  base: ['group/row', 'border-b border-gray-200', 'transition-colors duration-150', 'hover:bg-gray-50'],
  variants: {
    disabled: {
      false: 'cursor-pointer',
      true: 'cursor-not-allowed opacity-50',
    },
  },
});

interface UsersRowLoadingProps {
  showRoleScope?: boolean;
}

const UsersRowLoading = React.memo(({ showRoleScope = false }: UsersRowLoadingProps) => {
  return (
    <Row className={cx(rowClasses({ disabled: true }))} aria-label="Loading user row">
      <Cell className="py-8 px-12">
        <div className="flex items-center">
          <Skeleton className="h-10 w-48" variant="square" />
        </div>
      </Cell>

      {showRoleScope && (
        <>
          <Cell className="py-8 px-12 w-auto">
            <div className="flex items-center">
              <Skeleton className="h-8 w-24" variant="rounded" />
            </div>
          </Cell>

          <Cell className="py-8 px-12 w-auto">
            <div className="flex items-center">
              <Skeleton className="h-8 w-28" variant="rounded" />
            </div>
          </Cell>
        </>
      )}

      {/* Status Cell with potential resend button */}
      <Cell className="py-8 px-12 w-auto">
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-20" variant="rounded" />
          <Skeleton className="h-8 w-8" variant="rounded" />
        </div>
      </Cell>

      {/* Last Login Cell */}
      <Cell className="py-8 px-12 w-auto">
        <div className="flex items-center">
          <Skeleton className="h-10 w-24" variant="square" />
        </div>
      </Cell>

      {/* Actions Cell */}
      <Cell className="py-8 px-12 w-auto">
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-8" variant="rounded" />
        </div>
      </Cell>
    </Row>
  );
});

UsersRowLoading.displayName = 'UsersRowLoading';

export { UsersRowLoading };
